import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/topic/pageContext';

export const TopicErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for topic page (error: ${error})`);
};
